import React from 'react';

import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import PopupLoader from 'components/common/PopupLoader';
import { addAlert } from 'store/actions/alert/alerts';
import { authPostRequest } from 'helpers/apiRequests';
import { Grid } from '@material-ui/core';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import Map from 'components/common/components/drawMap/Map';

import { formStyles } from 'consts/styles/Form';
import AddZoneForm from '../ZoneDetailsForm';
import {
  borderValues,
  validateCheck,
  validateData,
} from '../../utils/zoneDetailsUtils';

const AddZone = props => {
  const { handleAddZone } = props;

  const dispatch = useDispatch();

  const strings = useSelector(state => state.language);

  const [seeableLoader, setSeeableLoader] = React.useState(false);
  const [geojson, setGeojson] = React.useState(null);
  const [values, setValues] = React.useState({
    othername: '',
    description: '',
    elevation_type: 'srtm',
    visibility: 'private',
    type: '',
    category: 'zone',
    agl_min: 40,
    agl_max: 60,
    amsl_max: 0,
    amsl_min: 0,
    contact: '',
    active: true,
    name: '',
  });
  const [errors, setErrors] = React.useState({});

  const formClasses = formStyles();

  const save = async () => {
    const data = { ...values };
    data.agl_min = parseInt(data.agl_min);
    data.agl_max = parseInt(data.agl_max);
    data.geojson = geojson;
    data.name = `${values.type} ${
      UserSessionDataHandler.getUserDataObject().organization
    } ${values.othername}`;
    const dataErrors = validateData(data);
    if (dataErrors) {
      setErrors(dataErrors);
      return;
    }
    setSeeableLoader(true);
    const result = await authPostRequest('areas', data);
    if (result?.status === 201) {
      dispatch(
        addAlert({
          title: strings.alerts.addDataSuccess.title_,
          desc: strings.alerts.addDataSuccess.desc_,
          type: 'success',
        })
      );
      handleAddZone(result.data);
      setSeeableLoader(false);
    } else
      dispatch(
        addAlert({
          title: strings.alerts[7].title_,
          desc: strings.alerts[7].desc_,
          type: 'error',
        })
      );
    setSeeableLoader(false);
  };

  const handleChange = event => {
    const { target } = event;
    const { name, value } = target;
    const ifCheckIsTrue = validateCheck(name, value);

    setValues({
      ...values,
      [name]: value,
    });

    setErrors({ ...errors, [name]: !ifCheckIsTrue });
  };

  return (
    <>
      {seeableLoader && <PopupLoader />}
      <Grid item>
        <Grid container spacing={2}>
          <Grid
            item
            xs={7}
            className={`${formClasses.Form}__overflow-component ${formClasses.Form}__overflow-component--with-map`}
          >
            <Map
              setErrors={setErrors}
              errors={errors}
              handleChange={handleChange}
              setGeojson={setGeojson}
              geojson={geojson}
              drawTypes={['circle', 'polygon']}
            />
          </Grid>
          <Grid
            item
            xs={5}
            className={`${formClasses.Form}__overflow-component`}
          >
            <AddZoneForm
              save={save}
              values={values}
              errors={errors}
              handleChange={handleChange}
              borderValues={borderValues}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

AddZone.propTypes = {
  handleAddZone: PropTypes.func.isRequired,
};

export default AddZone;
